import React, { useMemo } from 'react';
import { useLineImageWidget } from './hooks/useLineImageWidget';
import { useLineInfo } from '../../../providers/useLineInfoProvider';
import { DataRenderer } from 'components/machine-health';
import { LineImageWidgetContainer } from './LineImageWidget.elements';

export const LineImageWidget = (): JSX.Element => {
  const { lineId } = useLineInfo();

  const { data, isLoading, isError } = useLineImageWidget({ lineId });

  //display default image or image from data
  const defaultImage = `/assets/placeholder/no-image-found.svg`;
  const imageToUse = data?.[0]?.url || defaultImage;
  const Image = <img src={imageToUse} alt={data?.[0]?.name} />;

  const Main = useMemo(() => {
    return (
      <LineImageWidgetContainer className="line-image-widget">
        <DataRenderer isLoading={isLoading} error={isError}>
          {Image}
        </DataRenderer>
      </LineImageWidgetContainer>
    );
  }, [data, isLoading, isError]);

  return Main;
};
